import React from 'react';
import PropTypes from 'prop-types';

function withPagination(WrappedComponent, pageSize = 20, disablePagination = false, initialMount = true) {
  const rowsBeforeRefresh = 2;
  let actualPageNumber;
  class Pagination extends React.Component {
    componentDidMount() {
      actualPageNumber = 1;
      if (initialMount) this.props.onMount(pageSize);
    }

    handleRowsRendered = ({ stopIndex }, end) => {
      if (
        !disablePagination &&
        (end || (stopIndex + rowsBeforeRefresh) / pageSize > actualPageNumber) &&
        !(this.props.rows.length < actualPageNumber * pageSize)
      ) {
        actualPageNumber += 1;
        this.props.append(actualPageNumber, pageSize);
      }
    };

    render() {
      const { ...props } = this.props;
      return <WrappedComponent onRowsRendered={this.handleRowsRendered} {...props} />;
    }
  }

  Pagination.propTypes = {
    onMount: PropTypes.func.isRequired,
    append: PropTypes.func.isRequired,
    rows: PropTypes.array.isRequired // eslint-disable-line react/forbid-prop-types
  };
  return Pagination;
}

export default withPagination;
